"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExampleSub = exports.Example = exports.ExampleViewStore = undefined;

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _getOwnPropertyDescriptor = require("babel-runtime/core-js/object/get-own-property-descriptor");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _desc, _value, _class, _class2, _class3, _temp, _class4;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = require("mobx");

var _mobxReact = require("mobx-react");

var _simboxEditable = require("simbox-editable");

var _autoclassDecorator = require("autoclass-decorator");

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

var _baseViewstore = require("base-viewstore");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _baseComponent = require("base-component");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

// this is like a ViewModel, contains all user actions for this component
var ExampleViewStore = exports.ExampleViewStore = (_dec = _mobx.action.bound, (_class = function (_BaseViewStore) {
  (0, _inherits3.default)(ExampleViewStore, _BaseViewStore);

  function ExampleViewStore() {
    (0, _classCallCheck3.default)(this, ExampleViewStore);
    return (0, _possibleConstructorReturn3.default)(this, (ExampleViewStore.__proto__ || (0, _getPrototypeOf2.default)(ExampleViewStore)).apply(this, arguments));
  }

  (0, _createClass3.default)(ExampleViewStore, [{
    key: "save",
    value: function save() {
      var _this2 = this;

      var _props = this.props,
          contentModel = _props.contentModel,
          inputStore = _props.inputStore;

      inputStore && inputStore.setInput(contentModel, "isCompleted", true);
      inputStore && inputStore.saveData(function () {
        return console.log(_this2.id + " saved!");
      });
    }
  }, {
    key: "invalid",
    get: function get() {
      var invalid = {};
      var _props2 = this.props,
          activity = _props2.contentModel,
          inputStore = _props2.inputStore;


      var userInputValue = inputStore && inputStore.getInput(activity, "userInput");

      if (!userInputValue) invalid.userInput = "User, please provide a value!";

      return invalid;
    }
  }]);
  return ExampleViewStore;
}(_baseViewstore2.default), (_applyDecoratedDescriptor(_class.prototype, "invalid", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "invalid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "save", [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "save"), _class.prototype)), _class));

// this automatically gives consistent `className`s to components using module and component names
var Example = exports.Example = (0, _simboxEditable.Decorator)(_class2 = (0, _mobxReact.observer)(_class2 = (0, _autoclassDecorator2.default)(_class2 = (_temp = _class3 = function (_BaseComponent) {
  (0, _inherits3.default)(Example, _BaseComponent);

  function Example() {
    (0, _classCallCheck3.default)(this, Example);
    return (0, _possibleConstructorReturn3.default)(this, (Example.__proto__ || (0, _getPrototypeOf2.default)(Example)).apply(this, arguments));
  }

  (0, _createClass3.default)(Example, [{
    key: "render",
    //ViewStore gets auto-instantiated and attached to the component on creation
    value: function render() {
      var _props3 = this.props,
          currentView = _props3.currentView,
          contentModel = _props3.contentModel,
          inputStore = _props3.inputStore;
      var textSlot = contentModel.textSlot,
          richTextSlot = contentModel.richTextSlot,
          textOptionsSlot = contentModel.textOptionsSlot,
          numberSlot = contentModel.numberSlot,
          booleanSlot = contentModel.booleanSlot,
          referenceSlot = contentModel.referenceSlot,
          referenceArraySlot = contentModel.referenceArraySlot; // this contentModel's properties

      var _viewStore = this.viewStore,
          invalid = _viewStore.invalid,
          save = _viewStore.save; // this components viewStore.  Will have actions and UI properties

      var isDirty = inputStore && inputStore.isDirty;
      var isLoading = inputStore && inputStore.isLoading;
      var revert = inputStore ? inputStore.revert : function () {};

      function createMarkup(html) {
        return { __html: html };
      }

      if (isLoading) return _react2.default.createElement(
        "div",
        null,
        "Loading..."
      );

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { className: "header" },
          _react2.default.createElement(
            "h2",
            { className: "title" },
            textOptionsSlot,
            " - ",
            numberSlot
          ),
          _react2.default.createElement(
            "div",
            { className: "subtitle" },
            textSlot
          ),
          !!booleanSlot && _react2.default.createElement(
            "div",
            { className: "boolean" },
            "Boolean selected"
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "content-area" },
          _react2.default.createElement(
            "div",
            { className: "left-column" },
            _react2.default.createElement("div", { dangerouslySetInnerHTML: createMarkup(richTextSlot) }),
            _react2.default.createElement("hr", null),
            !!invalid.userInput && _react2.default.createElement(
              "div",
              { className: "validation-error" },
              invalid.userInput
            ),
            _react2.default.createElement("input", { type: "text", value: inputStore && inputStore.getInput(contentModel, "userInput"), onChange: function onChange(e) {
                return inputStore && inputStore.setInput(contentModel, "userInput", e.target.value);
              } }),
            _react2.default.createElement("textarea", { disabled: "true", value: inputStore && inputStore.getInput(contentModel, "userInput_computed") }),
            _react2.default.createElement("hr", null),
            _react2.default.createElement(
              "button",
              { id: "save-button", onClick: save, disabled: (0, _keys2.default)(invalid).length || !isDirty },
              "Save"
            ),
            _react2.default.createElement(
              "button",
              { id: "revert-button", onClick: revert, disabled: !isDirty },
              "Undo"
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "center-column" },
            _react2.default.createElement(
              "div",
              null,
              "Single / direct reference slot:"
            ),
            _react2.default.createElement(ExampleSub, { "data-editable": [contentModel, "referenceSlot"], contentModel: referenceSlot })
          ),
          _react2.default.createElement(
            "div",
            { className: "right-column", "data-editable": [contentModel, "referenceArraySlot"] },
            _react2.default.createElement(
              "div",
              null,
              "Array of references slot:"
            ),
            referenceArraySlot.length > 0 && referenceArraySlot.map(function (cm) {
              return cm && _react2.default.createElement(ExampleSub, { key: cm.id, contentModel: cm });
            })
          )
        )
      );
    }
  }]);
  return Example;
}(_baseComponent2.default), _class3.ViewStore = ExampleViewStore, _temp)) || _class2) || _class2) || _class2;

exports.default = Example; //need to export top level component as "default"

var ExampleSub = exports.ExampleSub = (0, _simboxEditable.Decorator)(_class4 = (0, _mobxReact.observer)(_class4 = (0, _autoclassDecorator2.default)(_class4 = function (_BaseComponent2) {
  (0, _inherits3.default)(ExampleSub, _BaseComponent2);

  function ExampleSub() {
    (0, _classCallCheck3.default)(this, ExampleSub);
    return (0, _possibleConstructorReturn3.default)(this, (ExampleSub.__proto__ || (0, _getPrototypeOf2.default)(ExampleSub)).apply(this, arguments));
  }

  (0, _createClass3.default)(ExampleSub, [{
    key: "render",
    value: function render() {
      var contentModel = this.props.contentModel;

      if (!contentModel) return _react2.default.createElement(
        "div",
        null,
        "No contentmodel supplied"
      );
      var text = contentModel.text,
          richText = contentModel.richText;


      function createMarkup(html) {
        return { __html: html };
      }

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { className: "title" },
          text
        ),
        _react2.default.createElement("div", { className: "body", dangerouslySetInnerHTML: createMarkup(richText) })
      );
    }
  }]);
  return ExampleSub;
}(_baseComponent2.default)) || _class4) || _class4) || _class4;


//////////////////
// WEBPACK FOOTER
// ./~/trc-example-activity/dist/component.js
// module id = ./node_modules/trc-example-activity/dist/component.js
// module chunks = 0